import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird, faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { styled } from '../styled';
import { Icon } from '../icon';
import { useTheme } from '../theme';
import { MouseInteraction } from '../animation';
const CircleButtonContainer = styled('button', ({ $theme, color, size = 50, $square }) => ({
    background: color ?? $theme.buttonBackground,
    height: size,
    width: size,
    borderRadius: $square === true ? size / 4 : '50%',
    border: 'none',
    color: 'white',
    cursor: 'pointer',
    fontSize: size / 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    flexGrow: 0
}));
export const CircleButtonWeb = React.memo(function CircleButton(props) {
    const $theme = useTheme();
    const [_isLoading, setIsLoading] = React.useState(false);
    const isLoading = _isLoading || props.isLoading;
    const onClick = React.useCallback(async (evt) => {
        if (isLoading === true) {
            return;
        }
        if (props.onClick != null) {
            if (props.awaitOnClickForLoading === true) {
                try {
                    setIsLoading(true);
                    await props.onClick(evt);
                    setIsLoading(false);
                }
                catch (e) {
                    setIsLoading(false);
                    throw e;
                }
            }
            else {
                props.onClick(evt);
            }
        }
    }, [isLoading, props.onClick]);
    return (_jsx(CircleButtonContainer, { onClick: onClick, size: props.size, _ref: props._ref, color: props.color ?? (props.secondary ? $theme.midground1 : undefined), "$square": props.square, children: _jsx(MouseInteraction, { children: isLoading ?
                _jsx(FontAwesomeIcon, { icon: faSpinnerThird, spin: true })
                :
                    _jsx(Icon, { icon: props.icon ?? faArrowRight, width: props.size / 2, color: "white" }) }) }));
});
